import React, { useContext, useEffect, useState } from 'react';
import './SearchResult.scss';
import { createPortal } from 'react-dom';
import AllForColumn2 from '../GalleryList/AllForColumn2';
import NoX from '../Common/NoX';
import SimpleBigPic from '../BigPic/SimpleBigPic';
import { ThemeContext } from '../../store/ThemeProvider';
import ReturnIcon from '../Common/ReturnIcon';
import { alpha } from '../../utils/color';
import useSimpleBigPic from "../BigPic/useSimpleBigPic";
import intl from 'react-intl-universal';

interface ISearchResult {
  close: () => void;
  keyword: string;
  list: any[];
}

const containerEl = document.createElement('div');
const SearchResult = function(props: ISearchResult) {
  useEffect(() => {
    document.body.appendChild(containerEl);
    return () => {
      document.body.removeChild(containerEl);
    };
  }, []);

  useEffect(() => {
    //这个弹窗显示的时候，隐藏掉Video
    window.dispatchEvent(new Event('hide-video'));
  }, []);
  // const [bigIndex, setBigIndex] = useState(-1);
  // const columnsClick = ({ index, id }: { index?: number; id: number }) => {
  //   const realIndex = list.findIndex(one => one.id === id);
  //   setBigIndex(realIndex);
  // };
  const { keyword } = props;
  const { componentColor, h1Color } = useContext(ThemeContext);

  const getReduceList = (array:any[])=>{
    if(array && array.length) {
      let one = array[0];
      return {
        [one.galleryid]:{
          images:array
        }
      };
    }

    return {};
  }

  const { list, columnsClick, setBigIndex, bigIndex, loadBigPic, loadFinish } = useSimpleBigPic(props.list);

  return createPortal(
    <div
      className="search-result"
      style={{ backgroundColor: alpha(componentColor, 1) }}
    >
      <div className="title" style={{ color: h1Color }}>
        {keyword}
      </div>
      {list.length === 0 ? (
        <NoX text={intl.get('NoResult')} />
      ) : (
        <div className="gallery-list">
          {' '}
          <AllForColumn2 list={list} onClick={columnsClick} lazy={false} />
        </div>
      )}
      <div className="search-result-return">
        <ReturnIcon onClick={props.close} />
      </div>
      <SimpleBigPic
        pageType="SearchResult"
        index={bigIndex}
        list={list}
        setIndex={setBigIndex}
        loadBigPic={loadBigPic}
        loadFinish={loadFinish}
      />
    </div>,
    containerEl
  );
};

export default SearchResult;
